import React, { useState } from 'react'
import MyButton from '../../UI/form/MyButton'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import MyModal from '../../UI/modal/MyModal';
import PackForm from './PackForm';

const PackFormAdd = ({ pack }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                pack ? <EditIcon /> : <AddIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Додати партію'}
            disableClickOutside={true}
            content={
                <PackForm
                    packBd={pack}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default PackFormAdd